import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  Breadcrumb,
  IBreadcrumb,
} from '../../shared/components/breadcrumb/breadcrumb';

import { mapUseCases } from '../../helpers/hospital-utils';
import { TableFeatureResponse } from '../../models/api-responses';
import { StateService } from '../../services/state.service';
import { DataSetDashboard } from './data-set-dashboard/data-set-dashboard';
import { DataSetSchema } from './data-set-schema/data-set-schema';

export interface IDataSet {
  description: string;
  timestamp: string;
  features: TableFeatureResponse[];
}

export enum FileType {
  Csv = 0,
  Dicom = 1,
  Vcf = 2,
  Xls = 3,
  Pdf = 4,
  Bam = 5,
}

@Component({
  selector: 'app-data-set',
  imports: [Breadcrumb, DataSetSchema, DataSetDashboard],
  templateUrl: './data-set.html',
  styleUrl: './data-set.scss',
})
export class DataSet implements OnInit {
  dataSetId: string;
  hospitalId: string;

  breadcrumbs = signal<IBreadcrumb[]>([]);
  hospitalName = signal<string>('Hospital');
  title = signal<string>('DataSet');
  subtitle = signal<string>('');
  activeTab = signal<string>('schema');
  dataSet = signal<IDataSet | null>(null);

  private route = inject(ActivatedRoute);
  private stateService = inject(StateService);

  constructor() {
    effect(() => {
      const dataSet = this.stateService.currentDataSetData$();
      if (dataSet) {
        this.activeTab.set('schema');
        const sideBarContent = this.stateService.sideBarContent$();
        const datasetName = sideBarContent
          .flatMap((y) => y.dataSets)
          .find((y) => y.id === dataSet.table.id)?.name;
        this.title.set(datasetName ?? 'DataSet');
        this.subtitle.set(
          dataSet?.table?.tableData?.useCase != null
            ? mapUseCases([dataSet.table.tableData.useCase])[0]
            : '',
        );

        this.hospitalName.set(
          sideBarContent.find((y) => y.id.toString() === this.hospitalId)
            ?.name ?? 'Hospital',
        );

        this.breadcrumbs.set([
          { label: 'Hospitals', url: '/home' },
          {
            label: this.hospitalName(),
            url: `/hospital-info/${this.hospitalId}`,
          },
          {
            label: `DataSet${this.dataSetId}`,
            url: `/hospital/${this.hospitalId}/data-set/${this.dataSetId}`,
          },
        ]);

        this.dataSet.set({
          description: 'placeholder use case',
          timestamp: dataSet.table.tableData.lastSync,
          features: dataSet.table.tableData.features,
        });
      }
    });
  }

  ngOnInit() {
    this.dataSetId = this.route.snapshot.paramMap.get('dataSetId')!;
    this.hospitalId = this.route.snapshot.paramMap.get('hospitalId')!;
  }
}
